import api from "./api";

const inventoryService = {
  // Categories
  getCategories: (params) => api.get("/inventory/categories", { params }),
  createCategory: (data) => api.post("/inventory/categories", data),
  updateCategory: (id, data) => api.put(`/inventory/categories/${id}`, data),
  deleteCategory: (id) => api.delete(`/inventory/categories/${id}`),

  // Suppliers
  getSuppliers: (params) => api.get("/inventory/suppliers", { params }),
  getSupplierById: (id) => api.get(`/inventory/suppliers/${id}`),
  createSupplier: (data) => api.post("/inventory/suppliers", data),
  updateSupplier: (id, data) => api.put(`/inventory/suppliers/${id}`, data),
  deleteSupplier: (id) => api.delete(`/inventory/suppliers/${id}`),

  // Items
  getItems: (params) => api.get("/inventory/items", { params }),
  getLowStockItems: (params) => api.get("/inventory/items/low-stock", { params }),
  getItemById: (id) => api.get(`/inventory/items/${id}`),
  createItem: (data) => api.post("/inventory/items", data),
  updateItem: (id, data) => api.put(`/inventory/items/${id}`, data),
  deleteItem: (id) => api.delete(`/inventory/items/${id}`),

  // Transactions
  getTransactions: (params) => api.get("/inventory/transactions", { params }),
  getTransactionSummary: (params) => api.get("/inventory/transactions/summary", { params }),
  createTransaction: (data) => api.post("/inventory/transactions", data),
  deleteTransaction: (id) => api.delete(`/inventory/transactions/${id}`),
};

export default inventoryService;
